import { RootErrorComponent } from "@/components/root-error";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/error")({
  component: () => <RootErrorComponent />,
});
